//Generated File 
export default class TransactionRequestStatus{
	static readonly Failed = `Failed`;
	static readonly FailedByException = `FailedByException`;
	static readonly Initial = `Initial`;
	static readonly Processed = `Processed`;
	static readonly Processing = `Processing`;
	static readonly Retry = `Retry`;
}
